import { AddableModuleType } from "@formant/core/model/AddableModuleType";

export const defaultModuleSizes: {
    [key in AddableModuleType]: {
        width: number;
        height: number;
    };
} = {
    terminal: {
        width: 4,
        height: 4,
    },
    location: {
        width: 4,
        height: 4,
    },
    localization: {
        width: 4,
        height: 4,
    },
    "transform tree": {
        width: 4,
        height: 4,
    },
    "point cloud": {
        width: 4,
        height: 4,
    },
    image: {
        width: 4,
        height: 4,
    },
    json: {
        width: 4,
        height: 2,
    },
    bitset: {
        width: 4,
        height: 2,
    },
    boolean: {
        width: 4,
        height: 2,
    },
    text: {
        width: 4,
        height: 2,
    },
    file: {
        width: 4,
        height: 2,
    },
    battery: {
        width: 4,
        height: 4,
    },
    video: {
        width: 4,
        height: 4,
    },
    numeric: {
        width: 4,
        height: 2,
    },
    "numeric set": {
        width: 4,
        height: 4,
    },
    health: {
        width: 4,
        height: 4,
    },
    custom: {
        width: 6,
        height: 4,
    },
    analytics: {
        width: 6,
        height: 4,
    },
    controls: {
        width: 6,
        height: 3,
    },
    "joystick-controls": {
        width: 6,
        height: 3,
    },
    "button-controls": {
        width: 2,
        height: 2,
    },
    twist: {
        width: 2,
        height: 2,
    },
};
